import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function SearchArea(props: any) {
  let myProps = {
    list_opt: {},
    list: (inData: any) => { },
    categoryInfoArr: [],
    ...props
  };
  let select_subject_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });

  const go_search = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    myProps.list({
      "now_page": "1",
      [name]: value
    });
  };

  return (
    <div>
      <div className="my_flex_center">
        <select className="search-input_select" value={myProps.list_opt.s_category_seq}
          name="s_category_seq"
          onChange={go_search}
          style={{ width: 80 }}>
          <option value="">선택없음</option>
          {
            myProps.categoryInfoArr.map((item: any, idx: number) => {
              return (
                <option key={idx} value={item.a_seq}>{item.a_title}</option>
              );
            })
          }
        </select>
        <select className="search-input_select" value={myProps.list_opt.s_subject}
          name="s_subject"
          onChange={go_search}
          style={{ width: 80 }}>
          <option value="">과목</option>
          {
            select_subject_option_arr.map((item: any, idx: number) => {
              return (
                <option key={idx} value={item.value}>{item.text}</option>
              );
            })
          }
        </select>
        <input type="text" className="search-input" value={myProps.list_opt.s_title_like} name="s_title_like"
          onChange={go_search}
          placeholder="제목"
          style={{ width: 60 }} />
        <button className="btn btn-dark ml-1" onClick={() => { myProps.list({}); }}>검색</button>
      </div>
      <div>
        <label>
          <input type="checkbox" checked={myProps.list_opt.s_open_group == "main"}
            onChange={(e: any) => {
              let change_open_group = "";
              let s_textbook_in_now_period = "";
              if (e.target.checked) {
                change_open_group = "main";
                s_textbook_in_now_period = "1";
              }
              myProps.list({
                "now_page": 1,
                "s_open_group": change_open_group,
                "s_textbook_in_now_period": s_textbook_in_now_period
              });
            }} /> 공통
        </label>
      </div>
    </div>
  );
};
export default SearchArea;